module.exports = require("./rm.d.ts");